import Image from "next/image";
import Link from "next/link";

const ImageCardNew = ({ imgSrc, title, customClass, imgClass, hrefUrl = "#" }) => {
  return (
    <div>
      {imgSrc && (
        <div className="h-[250px] lg:h-[18.30vw] border border-[#ccc] p-4 mb-5 lg:mb-[1.5vw]">
          <Image
            src={imgSrc}
            alt={title}
            width={300}
            height={300}
            className={`!max-w-[100%] max-h-[100%] w-auto mx-auto h-auto ${imgClass && imgClass
              }`}
          />
        </div>
      )}
      {/* {hrefUrl ? <Link href={hrefUrl || ""}><h4 className={customClass}>{title}</h4></Link> : null} */}
    </div>
  );
};

export default ImageCardNew;
